var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeonGreenArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.828,
    height: 6.414,
    viewBox: "0 0 10.828 6.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-chevron-right",
    "data-name": "Icon feather-chevron-right",
    d: "M0,0,4,4,0,8",
    transform: "translate(9.414 1.414) rotate(90)",
    fill: "none",
    stroke: "#1df161",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeonGreenArrowIcon);
export default __webpack_public_path__ + "static/media/neon-green-arrow-icon.4884c3c7c3415976fe5d44474e05333f.svg";
export { ForwardRef as ReactComponent };